<template>
  <IElUploadFile
    ref="file"
    fileName="file"
    :uploadHandler="uploadHandler"
    isAuthUpload
    :fileType="fileType"
    style="display: none"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'BUploadExcel',
    props: {
      uploadResultHandler: {
        type: Function,
      },
    },
    data() {
      return {
        fileType: ['.xls', '.xlsx'],
        fileData: {},
      };
    },
    methods: {
      // 开始上传
      startFile(fileData = {}) {
        this.fileData = fileData;
        this.$refs.file.uploadFileHandler();
      },
      uploadHandler(formData) {
        for (const key in this.fileData) {
          formData.append(key, this.fileData[key]); // 添加额外参数
        }
        axios.post('http://121.43.169.142/api/v1/admin/upload', formData).then((res) => {
          this.uploadResultHandler && this.uploadResultHandler(res);
        });
      },
    },
  };
</script>

<style></style>
